import styled, { keyframes } from "styled-components";

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;

export const Wrapper = styled.div<{ visible: boolean; closing: boolean }>`
  position: fixed;
  bottom: 24px;
  right: 24px;
  transform: translateX(-50%);
  z-index: 9999;
  width: 360px;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease forwards;
  pointer-events: ${({ visible }) => (visible ? "all" : "none")};
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  border: 1px solid #e5e7eb;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;

  color: #4a5e83;
`;

export const TextGroup = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.p`
  margin: 0;
  height: 24px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 24px;

  color: #4a5e83;
`;

export const Subtitle = styled.p`
  margin: 0;
  height: 24px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 24px;

  color: #4a5e83;
`;

export const ProgressWrapper = styled.div`
  padding: 0 16px 12px;
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: 4px;
  background-color: #f3f4f6;
  border-radius: 99px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ progress: number; status: string }>`
  height: 100%;
  border-radius: 99px;
  width: ${({ progress }) => progress}%;
  transition: width 0.5s ease;
  background-color: ${({ status }) => {
    if (status === "completed") return "#22c55e";
    if (status === "failed") return "var(--red)";
    return "var(--red)";
  }};
`;

export const ProgressLabel = styled.p`
  margin: 0;
  font-size: 11px;
  color: #9ca3af;
  margin-top: 6px;
  text-align: right;
`;
